import { DomainConditionOptions, EntityConditionOptions, OrgConditionOptions } from '../types'
import { PlatformLevel } from '../enums/platform-level'

export const ensureDomain = (opts): opts is DomainConditionOptions => opts.platformLevel === PlatformLevel.DOMAIN
export const ensureOrg = (opts): opts is OrgConditionOptions => opts.platformLevel === PlatformLevel.ORG

export const ensureBreakdown =
    (bd: string) =>
    ({ breakdown }: EntityConditionOptions): boolean =>
        breakdown === bd
